import React, { FC, ReactElement } from 'react'

// Satflow marketplace logo. The green "wings" keep the brand colour; the
// large "S" mark uses currentColor so it renders black in light mode and
// white in dark mode (set via `text-foreground` on the consumer).
const SatflowIcon: FC<{ className?: string }> = ({ className }): ReactElement => {
	return (
		<svg
			className={className}
			viewBox="0 0 167 140"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			aria-hidden="true"
		>
				<path d="M4 118H36.1L54.31 140H0L4 118Z" fill="#13C58F" />
				<path d="M14.75 56.6L47.5 57L65.31 78.4H11L14.75 56.6Z" fill="#13C58F" />
				<path d="M24.69 0H76.28L53.73 19.2H21.3L24.69 0Z" fill="#13C58F" />
				<path
					d="M46.1 118L49.1 101.8H71.91L69.91 112.4L76.31 120H119.74L128.94 112L133.54 86.2L127.34 78.4H75.31L57.3 56.6L63.71 19.2L86.32 0H147.95L166.36 22L163.36 38.4H140.55L142.35 27.6L135.94 20H94.32L85.32 27.6L81.12 50.8L87.52 58.4H139.55L157.56 80.2L150.15 121L127.94 140H64.31L46.1 118Z"
					fill="currentColor"
				/>
		</svg>
	)
}

export default SatflowIcon
